import { ResetBtn } from '@mi-front/ui';
import UploadIcon from '@mui/icons-material/Upload';
import { Alert, Box, Button, CircularProgress } from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { FormattedMessage } from 'react-intl';

export const UploadFile = ({
  importFn,
  onReset,
}: {
  importFn: () => Promise<any>;
  onReset: () => void;
}) => {
  const mutation = useMutation({
    mutationFn: importFn,
  });

  return (
    <>
      {(mutation.isIdle || mutation.isPending) && (
        <>
          <Button
            color="warning"
            variant="contained"
            className={'mr-3'}
            disabled={mutation.isPending}
            startIcon={
              mutation.isPending ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <UploadIcon fontSize="small" />
              )
            }
            onClick={() => mutation.mutate()}
          >
            <FormattedMessage id="validateUpload.process" defaultMessage="Procesar" />
          </Button>

          <ResetBtn disabled={mutation.isPending} onClick={onReset} />
        </>
      )}

      {mutation.isSuccess && (
        <Alert severity="success" sx={{ fontSize: 'medium', my: 3 }}>
          <FormattedMessage
            id="validateUpload.itemsCreated"
            defaultMessage="{count} items creados"
            values={{ count: mutation.data.length }}
          />
          <Box mt={3}>
            <Button color="inherit" variant="outlined" size="small" onClick={onReset}>
              <FormattedMessage
                id="validateUpload.processNewFile"
                defaultMessage="Procesar nuevo archivo"
              />
            </Button>
          </Box>
        </Alert>
      )}

      {mutation.isError && (
        <Alert severity="error" sx={{ fontSize: 'medium' }}>
          {mutation.error?.message ?? String(mutation.error)}
        </Alert>
      )}
    </>
  );
};
